<template>
	<div class="createParks">
		<div class="main-filter">
			<el-form inline :model="queryData" class="demo-form-inline search-form">
				<el-form-item label="驻派组名称：">
					<el-autocomplete v-model.trim="queryData.name" :fetch-suggestions="querySearchAsync" clearable placeholder="请输入内容"></el-autocomplete>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" icon="el-icon-search">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="main-content">
			<div class="main-content-title">
				<p>共有 {{ total }} 条结果</p>
				<el-button type="primary" @click="modifyParkInfo($event, false)" icon="el-icon-plus">新增</el-button>
			</div>
			<Table
				:loading="loading"
				:table-data="tableData"
				:total="total"
				:table-head="tableHead"
				:current-page.sync="queryData.current"
				:page-size.sync="queryData.size"
				:is-show-selection="false"
				:operation-column-width="140"
				:showOperation="true"
				@change-page="getList"
				:tableHeight="tableHeight"
			>
				<template #enabled="{ scope }">
					<el-switch inactive-text="否" active-text="是" v-model="scope.row.enabled" @change="changeOpen(scope.row)"> </el-switch>
				</template>
				<!-- 插槽操作栏固定属性operation -->
				<template #operation="{ scope }">
					<el-button @click="modifyParkInfo($event, true, scope.row)" size="mini" type="primary"> 查看 </el-button>
					<el-button
						@click="modifyParkInfo($event, false, scope.row)"
						size="mini"
						:type="scope.row.enabled ? 'info' : 'warning'"
						:disabled="scope.row.enabled"
					>
						修改
					</el-button>
				</template>
				<template #seeMore="{ scope }">
					<el-button class="seeMore" type="text" size="mini" @click="seeMore(scope.row)">查看（{{ scope.row.medicalWorkers.length }}）</el-button>
				</template>
			</Table>
		</div>
		<createView @getList="getList" ref="createView" :isShowDetail="isShowDetail" :option="option" />
		<show ref="show" :checkRow="checkRow"></show>
	</div>
</template>

<script>
export default {
	name: 'countyMedicalInstitution',
	components: {
		Table: () => import('@/components/Table/table'),
		createView: () => import('./newDialog.vue'),
		show: () => import('./show.vue'),
	},
	data() {
		return {
			loading: false,
			checkRow: {},
			queryData: {
				current: 1,
				size: 10,
				discriminationCode: 'D',
			},
			total: 0,
			options: [],
			tableData: [],
			tableHead: [
				{
					label: '驻派组名称',
					prop: 'name',
					formatter: (row) => {
						return row.name || '-';
					},
				},
				{
					label: '驻派组成员',
					prop: 'seeMore',
				},
				{
					label: '负责人',
					prop: 'principalName',
				},
				{
					label: '联系电话',
					prop: 'phoneNumber',
				},
				{
					label: '创建日期',
					prop: 'createTime',
				},
				{
					label: '驻派组状态',
					prop: 'state',
					formatter: (row) => {
						return row.state == 'I' ? '闲置' : '驻派中';
					},
				},
				{
					label: '是否启用',
					prop: 'enabled',
					width: 110,
				},
			],
			filterLoading: false,
			isShowDetail: false,
			link: '',
			option: [],
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
	},
	mounted() {
		this.getList();
		this.getUserList();
	},
	methods: {
		seeMore(item) {
			this.checkRow = item;
			this.$refs.show.showVisible = true;
		},
		// 搜索建议
		querySearchAsync(queryString, cb) {
			queryString ? this.getList('filter') : '';
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(this.options);
			}, 1000 * Math.random());
		},
		onSearch(data) {
			this.queryData.current = 1;
			this.getList('', data);
		},
		changeOpen(row) {
			this.$http
				.patch(row._links.patch.href, { enabled: row.enabled })
				.then((res) => {
					if (res.data && res.data.success) {
						this.$message.success('操作成功');
						this.getList();
					}
				})
				.catch((e) => {});
		},
		//获取列表
		getList(type = '', searchData = {}) {
			type == 'filter' ? '' : (this.loading = true);
			console.log(type, searchData, '1111');
			let data = {
				...searchData,
				...this.queryData,
			};
			this.$http
				.get(this.api['MedicalWorkerGroups#index'].href, { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						if (type == 'filter') {
							this.filterLoading = false;
							this.options = res.data.collection.map((item) => {
								return {
									...item,
									value: item.name,
								};
							});
						} else {
							this.tableData = res.data.collection || [];
							this.total = res.data.pagination.totalItems || 0;
							this.loading = false;
							this.link = res.data._links.create.href || '';
						}
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
		modifyParkInfo(event, isShowDetail, row) {
			let data = {
				row: row || null,
				link: row ? row._links.update.href : this.link,
			};
			this.$refs.createView.init(data);
			this.isShowDetail = isShowDetail;
		},
		// 获取成员列表
		getUserList() {
			this.$http
				.get(this.api['MedicalWorkers#index'].href, { params: { current: 1, size: 9999 } })
				.then((res) => {
					if (res.data && res.data.success) {
						this.option = res.data.collection || [];
					}
				})
				.catch((e) => {});
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .search-form {
	.el-select {
		width: 120px;
		.el-input {
			width: 120px;
			.el-input__inner {
				width: 120px;
			}
		}
	}
	.el-input {
		width: 160px;
	}
}
.main-content {
	&-title {
		line-height: 48px;
		display: flex;
		justify-content: space-between;
		.el-button {
			line-height: 32px;
			padding: 0 16px;
			height: 32px;
			margin-top: 8px;
		}
	}
}
.seeMore {
	color: #1db9b1;
}
</style>
